// extracted by mini-css-extract-plugin
module.exports = {"pastCourse":"PastCourse_pastCourse__3odRR","borderContent":"PastCourse_borderContent__2Rh-r"};